import { PermissionsScope } from '../../policies/policy.model'

export const BANNER_SCOPE: PermissionsScope = 'banners'
export const BANNER_FRAGMENT = 'banner'
